import api from 'plugin/api';

/**
 *  모니터링 - 공통 API
 */

/**
 *  @description 한계기준이탈수 및 한계기준이탈현황 API
 */
async function excdInfoCount(params) {
  const url = '/sfsh/monitoring/excdInfo/cnt';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 한계기준이탈현황 - 목록 API
 */
async function excdInfoList(params) {
  const url = '/sfsh/monitoring/excdInfo';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 한계기준이탈현황 - 상세 API
 */
async function excdInfoDetail(seq) {
  const url = `/sfsh/monitoring/excdInfo/${seq}`;

  const response = await api.get(url);
  return response;
}

/**
 *  @description 한계기준이탈현황 - 조치내역목록 API
 */
async function approvalList(params) {
  const url = '/sfsh/monitoring/excdInfo/approval';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 한계기준이탈현황 - 조치내역등록 API
 */
async function approvalCreate(seq, requestBody) {
  const url = `/sfsh/monitoring/excdInfo/${seq}/approval`;

  const response = await api.post(url, requestBody);
  return response;
}

/**
 *  @description 모니터링 CCP관리현황 API
 */
async function ccpManagementStatus(params) {
  const url = '/sfsh/monitoring/ccpInfo/cnt';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description CCP관리현황 자세히보기 목록API
 */
async function ccpInfoList(params) {
  const {
    pltCd,
    ctgryGrpCd,
    inspResultType = '',
    ccpExcdYn = '',
    inspReqDtSt,
    inspReqDtEn,
    ctgry1Cd = '',
    page = 0,
    size,
    sort,
    sort1,
    sort2,
    sort3,
    sort4,
    sort5
  } = params || {};

  const url = `/sfsh/monitoring/ccpInfo?pltCd=${pltCd}&inspResultType=${inspResultType}&ccpExcdYn=${ccpExcdYn}&inspReqDtSt=${inspReqDtSt}&inspReqDtEn=${inspReqDtEn}&ctgryGrpCd=${ctgryGrpCd}&page=${page}&size=${size}&ctgry1Cd=${ctgry1Cd}&sort=${sort}&sort=${sort1}&sort=${sort2}&sort=${sort3}&sort=${sort4}&sort=${sort5}`;

  const response = await api.get(url);
  return response;
}

/**
 *  @description 할일 건수 API
 */
async function todoInfo(params) {
  const url = '/sfsh/monitoring/todo/cnt';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 할일 자세히보기 - 목록API
 */
async function todoList(params) {
  const url = '/sfsh/monitoring/todo';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 검사결과 - 상세API
 */
async function resultDetail(seq) {
  const url = `/sfsh/inspection/result/${seq}`;

  const response = await api.get(url);
  return response;
}

/**
 *  @description 알람 - 조회API
 *  1: 모선 정기분석일 알람
    2: 한계기준이탈 미등록 알람
    3: 한계기준이탈 조치내역 알람
    4: 리포트 결재 알람
 */
async function alarmInfo() {
  const url = `/sfsh/alarm`;

  const response = await api.get(url);
  return response;
}
export {
  excdInfoCount,
  excdInfoList,
  excdInfoDetail,
  approvalList,
  approvalCreate,
  ccpManagementStatus,
  ccpInfoList,
  todoInfo,
  todoList,
  resultDetail,
  alarmInfo
};
